/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { useMemo } from 'react';
import Tooltip from 'rc-tooltip';
import { MonitorProcessData } from '@/types/models';
import { useJobsProcessInfoData } from './JobsMonitorContext';
import { Skeleton } from 'primereact/skeleton';
interface Props {
  className?: string;
  monitorData: MonitorProcessData;
}
export const ProcessDescription: React.FC<Props> = ({ className, monitorData }) => {
  const { processesInfoData } = useJobsProcessInfoData();

  const rowProcessInfo = useMemo(() => {
    if (processesInfoData && monitorData) {
      const rowInfo = processesInfoData?.find(
        (el) => el.fecthStatus === 'sucessfull' && el.processId == monitorData.id
      );
      return rowInfo;
    }
  }, [processesInfoData, monitorData]);

  const isFetchInfo = useMemo(() => {
    if (!rowProcessInfo) {
      const emptyRowData = processesInfoData?.some(
        (el) => el.processId == monitorData.id && el.fecthStatus === 'failed'
      );
      return !monitorData.id.startsWith('dyna~') && !emptyRowData && true;
    }
    return rowProcessInfo.fecthStatus === 'pending';
  }, [rowProcessInfo, monitorData, processesInfoData]);

  return (
    <>
      {isFetchInfo ? (
        <Skeleton width={'100%'} height="1rem" />
      ) : (
        rowProcessInfo?.data && (
          <div className="flex align-items-center">
            <span className={className}>{rowProcessInfo.data.process_title ?? ''}&nbsp;&nbsp;</span>
            {rowProcessInfo.data.process_description && (
              <Tooltip
                placement="bottom"
                overlay={
                  <div style={{ minWidth: '10rem', maxWidth: '20rem' }} className="flex flex-column  mb-1">
                    {rowProcessInfo.data.process_description}
                  </div>
                }
              >
                <i className="pi pi-info-circle" />
              </Tooltip>
            )}
          </div>
        )
      )}
    </>
  );
};
